import styled from 'styled-components';
import color from 'tinycolor2';

import {
  List as ListComponent,
  ListBody as ListBodyComponent,
  ListItem as ListItemComponent,
  ListItemColumn,
} from '@pearsontechnology/aero-components';

export const Avatar = styled.img`
  border-radius: 50%;
  box-sizing: border-box;
  height: 30px;
  width: 30px;
`;

export const List = styled(ListComponent)`
  box-shadow: none;

  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 19px;
  margin-right: -10px;
  padding-right: 0 10px;

  flex: 1;

  @media (min-width: 480px) {
    max-height: 212px;
  }
`;

export const ListBody = styled(ListBodyComponent)`
  box-shadow: none;
`;

export const ListItem = styled(ListItemComponent)`
  padding: 4px 0;
  font-size: 13px;
  line-height: 16px;
  min-height: 30px;

  & button {
    min-height: 10px;
    height: 30px;
    font-size: 13px;
    line-height: 16px;
    text-align: right;
    text-transform: capitalize;
    letter-spacing: normal;
    font-weight: 600;
  }
`;

export const ListColumn = styled(ListItemColumn)`
  border: 0;
  padding: 4px 0;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`;

export const TeamIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${(props) => color(props.theme['color.primary']).setAlpha(0.2).toString()};
  color: ${(props) => props.theme['color.primary']};
`;

export const InvitePageWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const PlaceholderAvatar = styled.div`
  width: 34px;
  height: 34px;
  background: ${(props) => color.mix(props.theme['color.text.light'], props.theme['color.surface'], 90).toString()};
  border-radius: 50%;
  border: 2px solid ${(props) => props.theme['color.surface']};
  margin-right: -10px;
  float: right;
`;
